import React from "react"
import { Tabs, Tab, TabPanel, TabList } from "react-web-tabs"
import ProfileSettings from "./ProfileSettings/ProfileSettings"
import UserAddress from "./AddressSettings/UserAddress"
import useCustomerData from "./useCustomerData"
import CardSettings from "./CardSettings/CardSettings"
import NotificationSettings from "./NotificationSettings/NotificationSettings"

export default function SettingsTab({ notify }) {
  const { customer, auth, addressList, stripeCustomer, paymentMethods } =
    useCustomerData()
  return (
    <Tabs defaultTab="profile" vertical id="flex-wrapper">
      <TabList
        id="tablist"
        style={{
          position: "sticky",
          top: "0",
          alignSelf: "flex-start",
        }}
      >
        <Tab tabFor="profile">Profile</Tab>
        <Tab tabFor="addresses">Addresses</Tab>
        <Tab tabFor="paymentMethods">Payment Methods</Tab>
        <Tab tabFor="notifications">Notifications</Tab>
        <Tab tabFor="support">Support</Tab>
      </TabList>
      <TabPanel tabId="profile">
        <ProfileSettings notify={notify} customer={customer} auth={auth} />
      </TabPanel>
      <TabPanel tabId="addresses">
        <UserAddress addressList={addressList} auth={auth} notify={notify} />
      </TabPanel>
      <TabPanel tabId="notifications">
        <NotificationSettings customer={customer} notify={notify} auth={auth} />
      </TabPanel>
      <TabPanel tabId="paymentMethods">
        <CardSettings
          auth={auth}
          stripeCustomer={stripeCustomer}
          paymentMethods={paymentMethods}
        />
      </TabPanel>
      <TabPanel tabId="support">
        <p>Support content</p>
      </TabPanel>
    </Tabs>
  )
}
